import { Injectable } from '@angular/core';
import type { ParseValueResult } from "./models/parse-value-result";

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  public parseValue(value: string): ParseValueResult {
    const normalizedValue = value.trim();

    if (normalizedValue === '') {
      return { isValid: true, value: null };
    }

    if (!this.hasValidDecimalValueFormat(normalizedValue)) {
      return { isValid: false, value: null };
    }

    const amount = Number(normalizedValue);
    return Number.isFinite(amount)
      ? { isValid: true, value: amount }
      : { isValid: false, value: null };
  }

  private hasValidDecimalValueFormat(value: string): boolean {
    return /^-?(?:\d+(?:\.\d{1,2})?|\.\d{1,2})$/.test(value);
  }
}
